<nav class="navbar navbar-expand-md navbar-dark bg-primary"
  *ngIf="(isLoggedIn | async) && (!fhirEmbedded || fhirFullSite)" style="height:56px">
  <a *ngIf="channelsAppUrl && hasBrandImage && !channelsUrl" class="navbar-brand header-logo"
    [routerLink]="channelsAppUrl">
    <img *ngIf="brandImageLoaded" alt="{{'LOGO' | translate}}" class="header-logo-image" [src]="brandImageUrl">
  </a>
  <a *ngIf="channelsUrl && hasBrandImage" class="navbar-brand header-logo" target="_blank" href="{{channelsUrl}}"
    rel="noreferrer">
    <img *ngIf="brandImageLoaded" alt="{{'LOGO' | translate}}" class="header-logo-image" [src]="brandImageUrl">
  </a>
  <img *ngIf="!channelsUrl && !channelsAppUrl && hasBrandImage && brandImageLoaded" alt="{{'LOGO' | translate}}"
    class="header-logo-image" [src]="brandImageUrl">
  <span *ngIf="applicationName" class="title application-name" [innerHTML]="applicationName"></span>
  <button class="navbar-toggler d-lg-none" type="button" (click)="isCollapsed = !isCollapsed"
    [attr.aria-expanded]="!isCollapsed" aria-controls="navbarsTop"
    attr.aria-label="{{'TOGGLE-NAVIGATION' | translate}}">
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="collapse navbar-collapse ml-5" id="navbarsTop" [ngbCollapse]="isCollapsed">
    <ul class="navbar-nav mr-auto">
      <li class="nav-item">
        <!-- TODO: Need to revisit if this is necessary for responsive views -->
        <!--<a class="nav-link k-text-uppercase" [routerLink]="['home']" [routerLinkActive]="['active']">{{ 'HOME' | translate }}</a>-->
      </li>
    </ul>
    <ul class="navbar-nav">
      <li class="nav-item navbar-right mr-4" *ngIf="hasHeaderImage && headerImageLoaded">
        <a *ngIf="headerUrl" target="_blank" href="{{headerUrl}}" rel="noreferrer">
          <img alt="{{'PHOTO' | translate}}" class="header-logo-client-image" [src]="headerImageUrl">
        </a>
        <img *ngIf="!headerUrl" alt="{{'PHOTO' | translate}}" class="header-logo-client-image" [src]="headerImageUrl">
      </li>
      <li class="nav-item navbar-right">
        <img alt="{{'PHOTO' | translate}}" *ngIf="hasUserImage && userImageLoaded" class="avatar-custom"
          [src]="userImageUrl" title="{{loggedInUserRole}}{{getLoggedInOrganization()}}">
        <kendo-avatar *ngIf="!hasUserImage && userImageLoaded && userInitials" class="avatar-custom" shape="circle"
          initials="{{userInitials|uppercase}}" title="{{loggedInUserRole}}{{getLoggedInOrganization()}}">
        </kendo-avatar>
      </li>
      <li class="nav-item navbar-right mr-4">
        <div ngbDropdown class="d-inline-block" style="margin-top:2px;">
          <button class="btn btn-outline-primary k-text-uppercase ml-2" id="dropdownHeader"
            ngbDropdownToggle>{{loggedInUserFullName}}</button>
          <div ngbDropdownMenu aria-labelledby="dropdownHeader" style="margin-left:7px;">
            <button class="dropdown-item k-text-uppercase" [routerLink]="['user/account']">
              <i class="fal fa-user-circle fa-header-nav-icon fa-fw"></i>{{'ACCOUNT' | translate }}
            </button>
            <button class="dropdown-item k-text-uppercase" [routerLink]="['help']">
              <i class="fal fa-question-circle fa-header-nav-icon fa-fw"></i>{{ 'HELP' | translate }}
            </button>
            <div *ngIf="activeRoles.length > 0 || (activeOrganizations.length > 0 && !isPayerRole)">
              <div class="dropdown-divider"></div>
              <button *ngIf="activeRoles.length > 0" class="dropdown-item k-text-uppercase" (click)="changeRole()">
                <i class="fal fa-user-check fa-header-nav-icon fa-fw"></i>{{ 'CHANGE-ROLE' | translate }}
              </button>
              <button *ngIf="activeOrganizations.length > 0 && !isPayerRole" class="dropdown-item k-text-uppercase"
                (click)="changeOrganization()">
                <i class="fal fa-hospital-user fa-header-nav-icon fa-fw"></i>{{ 'CHANGE-ORGANIZATION' | translate }}
              </button>
            </div>
            <div class="dropdown-divider"></div>
            <button class="dropdown-item k-text-uppercase" [routerLink]="['logout']" (click)="logout()">
              <i class="fal fa-sign-out-alt fa-header-nav-icon fa-fw"></i>{{ 'LOGOUT' | translate }}
            </button>
          </div>
        </div>
      </li>
    </ul>
    <span class="badge badge-pill badge-secondary badge-environment mr-3 {{environmentClass}}">{{ environmentText
      }}</span>
  </div>
</nav>
<app-select-role #selectRole></app-select-role>
<app-select-organization #selectOrganization></app-select-organization>